"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dictionary = void 0;
const mutation_manager_1 = require("../util/mutation-manager");
const dictionary_settings_1 = require("./dictionary-settings");
const error_1 = require("./error");
const marker_1 = require("./marker");
const search_result_1 = require("./search-result");
const word_1 = require("./word");
class Dictionary {
    constructor(words, settings, markers, path, mutationManager) {
        this.words = words;
        this.settings = settings;
        this.markers = markers;
        this.path = path;
        this.mutationManager = mutationManager !== null && mutationManager !== void 0 ? mutationManager : new mutation_manager_1.MutationManager();
        for (const word of words) {
            word.setDictionary(this);
        }
    }
    static fromPlain(plain) {
        const words = plain.words.map((plainWord) => word_1.Word.fromPlain(plainWord));
        const settings = dictionary_settings_1.DictionarySettings.fromPlain(plain.settings);
        const markers = marker_1.Markers.fromPlain(plain.markers);
        const path = plain.path;
        const mutationManager = mutation_manager_1.MutationManager.fromPlain(plain.mutationManager);
        const dictionary = new Dictionary(words, settings, markers, path, mutationManager);
        return dictionary;
    }
    toPlain() {
        const words = this.words.map((word) => word.toPlain());
        const settings = this.settings.toPlain();
        const markers = this.markers.toPlain();
        const path = this.path;
        const mutationManager = this.mutationManager.toPlain();
        return { words, settings, markers, path, mutationManager };
    }
    search(parameter) {
        const result = search_result_1.SearchResult.measure(() => {
            const words = [];
            const suggestions = [];
            parameter.prepare(this);
            suggestions.push(...parameter.presuggest(this));
            for (const word of this.words) {
                if (parameter.match(word)) {
                    words.push(word);
                }
                suggestions.push(...parameter.suggest(word, this));
            }
            word_1.Word.sortWords(words);
            return [words, suggestions];
        });
        return result;
    }
    findByUid(uid) {
        const word = this.words.find((word) => word.uid === uid);
        return word;
    }
    findByUniqueName(uniqueName, excludedUid) {
        const word = this.words.find((word) => {
            if (excludedUid !== undefined) {
                return word.uid !== excludedUid && word.uniqueName === uniqueName;
            }
            else {
                return word.uniqueName === uniqueName;
            }
        });
        return word;
    }
    addWord(newWord, skipValidate) {
        const errorType = (skipValidate) ? null : this.validateEditWord(null, newWord);
        if (errorType === null) {
            const newRealWord = word_1.Word.fromPlain(newWord);
            newRealWord.setDictionary(this);
            newRealWord.reissueUid();
            this.writableWords.push(newRealWord);
            this.mutationManager.change(newWord.uniqueName);
        }
        else {
            throw new error_1.ValidationError(errorType);
        }
    }
    editWord(uid, newWord, skipValidate) {
        const errorType = (skipValidate) ? null : this.validateEditWord(uid, newWord);
        if (errorType === null) {
            if (uid !== null) {
                const oldWord = this.words.find((word) => word.uid === uid);
                if (oldWord !== undefined) {
                    oldWord.edit(newWord);
                    this.mutationManager.rename(oldWord.uniqueName, newWord.uniqueName);
                }
            }
            else {
                const newRealWord = word_1.Word.fromPlain(newWord);
                newRealWord.setDictionary(this);
                newRealWord.reissueUid();
                this.writableWords.push(newRealWord);
                this.mutationManager.change(newWord.uniqueName);
            }
        }
        else {
            throw new error_1.ValidationError(errorType);
        }
    }
    deleteWord(uid) {
        const oldWordIndex = this.words.findIndex((word) => word.uid === uid);
        if (oldWordIndex >= 0) {
            const oldWord = this.words[oldWordIndex];
            this.writableWords.splice(oldWordIndex, 1);
            this.mutationManager.delete(oldWord.uniqueName);
        }
    }
    validateEditWord(uid, newWord) {
        if (uid !== null) {
            const oldWord = this.words.find((word) => word.uid === uid);
            if (oldWord !== undefined) {
                if (this.findByUniqueName(newWord.uniqueName, oldWord.uid) !== undefined) {
                    return "duplicateUniqueName";
                }
                else {
                    return oldWord.validateEdit(newWord);
                }
            }
            else {
                return "noSuchWord";
            }
        }
        else {
            if (this.findByUniqueName(newWord.uniqueName) !== undefined) {
                return "duplicateUniqueName";
            }
            else {
                return null;
            }
        }
    }
    changeSettings(newSettings) {
        const newRealSettings = dictionary_settings_1.DictionarySettings.fromPlain(newSettings);
        this.writable.settings = newRealSettings;
    }
    get writable() {
        return this;
    }
    get writableWords() {
        return this.words;
    }
}
exports.Dictionary = Dictionary;
